import { trpc } from '@/shared/api';

/** 기획전 목록(exhibitions.list) — 한 번으로 목적 탭과 카드를 모두 받는다. 탭 전환은 다시 요청하지 않는다. */
export const useExhibitionsQuery = () => trpc.exhibitions.list.useQuery();
